// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__tIirw","fadeIn":"Tooltip_fadeIn__0812W"};